<template>
  <div class="pageAdd">
    <div class="header">
      <myTitleName :titleName="title"></myTitleName>
    </div>
    <div class="content">
      <slot name="content"></slot>
    </div>
    <div class="footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    title:{
      type:String,
      default:'新增'
    }
  },
  data() {
    return {}
  },
  mounted() {
        
  },
  methods: {
        
  },
}
</script>

<style lang="scss" scoped>
.pageAdd{
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  background: #ffffff;
  width: 100%;
  height: 100%;
  .header{
    padding: 12px 20px;
    border-bottom: 1px solid #DCDFE6;
    .title{
      margin-bottom:0px
    }
  }
  .content{
    flex: 1;
    padding: 10px 20px;
    overflow: auto;
  }
  .footer{
    padding: 10px 20px;
    display: flex;
    justify-content: flex-end;
    border-top: 1px solid #DCDFE6;
  }
}
</style>